import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { GET_SINGLE_MANUAL_TEXT } from "./gql";
import { useQuery } from "@apollo/client";
import { Container, Paper, Typography } from "@mui/material";
import DOMPurify from "dompurify";
import { marked } from "marked";
import parse from "html-react-parser";
import { translateEntityKind } from "../../utils/FileTableUtils";
import styles from "./styles.module.css";
import LoadingCircle from "../../components/LoadingCircle";
import ErrorLayout from "../../components/layout/ErrorLayout";

export interface ManualTableType {
  createdAt: string;
  poznamka: string;
  id: string;
  relatedToEntity: string;
  text_cs: string;
  code: string;
}

const ManualDetail = () => {
  const { id } = useParams<{ id: string }>();

  const [manual, setManual] = useState<ManualTableType | null>(null);

  const {
    loading: manualLoading,
    error: manualError,
    data: manualData,
  } = useQuery(GET_SINGLE_MANUAL_TEXT, {
    variables: { id: parseInt(id || "") },
  });

  useEffect(() => {
    if (manualData) {
      setManual(manualData.textById);
    }
  }, [manualData]);

  if (manualError) return <ErrorLayout errorMsg={manualError.message || "Nastala chyba při načítání manuálu"} />;

  if (!manualLoading && !manual) return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
      <Typography variant="h1" style={{
        opacity: 0.8,
      }}>
        Manuál nebyl nalezen
      </Typography>
    </div>
  );

  if (manualLoading || !manual) return <LoadingCircle />;

  return (
    <Container className={styles.manualDetailContainer}>
      <Paper className={styles.manualDetailPaper}>
        <div className={styles.sectionContent}>
          <Typography variant="subtitle2" className={styles.sectionTitle}>
            Druh manuálu
          </Typography>
          <Typography variant="body1">
            {translateEntityKind(manualData.enumerations, manual?.relatedToEntity || "")}
          </Typography>
        </div>

        <div className={styles.sectionContent}>
          <Typography variant="subtitle2" className={styles.sectionTitle}>
            Popis
          </Typography>
          <Typography variant="body1">
            {manual?.poznamka}
          </Typography>
        </div>

        <div className={styles.sectionContent}>
          <Typography variant="subtitle2" className={styles.sectionTitle}>
            Nápověda
          </Typography>
          <div className={styles.manualContent}>
            {parse(
              DOMPurify.sanitize(
                marked(manual?.text_cs || "", { async: false })
              )
            )}
          </div>
        </div>
      </Paper>
    </Container>
  );
};

export default ManualDetail;
